module.exports = __webpack_public_path__ + "static/media/R1.60df28ea.png";